import React, {useState} from 'react';
import {NextSeo} from 'next-seo';
import HospitalIntro from '@components/MedicalFacilityDetails/HospitalIntro';
import MedialFacilityNav from '@components/MedicalFacility/MedialFacilityNav';
import Specialties from '@components/MedicalFacilityDetails/Specialties';
import MedicalFacilityServiceSection from '@components/MedicalFacilityDetails/MedicalFacilityServiceSection';
import InfrastructureCarousel from '@components/MedicalFacility/InfrastructureCarousel';
import MedicalFacilityDoctors from '@components/MedicalFacilityDetails/MedicalFacilityDoctors';
import FormRegister from '@components/MedicalFacilityDetails/FormRegister';
import MedicalFacilityCustomerComments from '@components/MedicalFacility/MedicalFacilityCustomerComments';
import SlideMedicalFacility from '@components/MedicalFacility/SlideMedicalFacility';
import {BookingProvider} from '@contexts/BookingContext';
import GoogleMapView from '@components/common/GoogleMap/GoogleMapPopup';

/**
 * Trang chi tiết cơ sở y tế
 * Hiển thị thông tin chi tiết về bệnh viện, bác sĩ, dịch vụ và form đặt lịch
 */
export default function MedialFacility(props) {
    const {preloadedMedicalFacility, hospitals = [], seoPage} = props;
    const [selectedMapUrl, setSelectedMapUrl] = useState(null);
    const [open, setOpen] = useState(false);

    // Xử lý dữ liệu bệnh viện (có thể là array hoặc object)
    const medicalFacility = Array.isArray(preloadedMedicalFacility)
        ? preloadedMedicalFacility[0]
        : preloadedMedicalFacility || null;

    const getMapUrl = name => {
        if (!name) return null;

        if (name.includes('Thái Nguyên') || name.includes('Thai Nguyen')) {
            return 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d7419.92591351833!2d105.82976!3d21.587369!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xc059ef64cbc6b293!2zQuG7h25oIFZp4buHbiBRdcO0zIFjIFTDqsyBIFRoYcyBaSBOZ3V5w6pu!5e0!3m2!1svi!2sus!4v1635393862311!5m2!1svi!2sus';
        } else if (name.includes('Phổ Yên') || name.includes('Pho Yen')) {
            return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d29716.751769817314!2d105.86719314840859!3d21.405886272490253!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x31351fe9a02a465d%3A0x861cba2d357f12c6!2zQuG7h25oIFZp4buHbiDEkGEgS2hvYSBZw6puIELDrG5oIFRow6FpIE5ndXnDqm4!5e0!3m2!1svi!2s!4v1686104129648!5m2!1svi!2s';
        } else if (name.includes('Việt Yên') || name.includes('Viet Yen')) {
            return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3718.113232067809!2d106.10101907424647!3d21.26698497955583!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x313513ef19bf8947%3A0x3a66fac7f166c8a!2zQuG7h25oIHZp4buHbiBUTkggVmnhu4d0IFnDqm4!5e0!3m2!1svi!2s!4v1734595877069!5m2!1svi!2s';
        } else if (name.includes('Lạng Sơn') || name.includes('Lang Son')) {
            return 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d2919.859095899616!2d106.74893180722017!3d21.847053483705068!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x36b54f0021135177%3A0x25c2c442cd3a15b0!2zQuG7h25oIHZp4buHbiBUTkggTOG6oW5nIFPGoW4!5e0!3m2!1svi!2s!4v1780049383996!5m2!1svi!2s';
        }
        return null;
    };

    const medicalFacilityWithMap = {
        ...medicalFacility,
        mapUrl: medicalFacility.mapUrl || getMapUrl(medicalFacility.business_name),
    };

    const handleOpenMap = mapUrl => {
        if (!mapUrl) return;
        setSelectedMapUrl(mapUrl);
        setOpen(true);
    };

    return (
        <BookingProvider>
            {seoPage && <NextSeo {...seoPage} />}
            {/* Hero section với thông tin bệnh viện */}
            <SlideMedicalFacility medicalFacility={medicalFacility} />

            {/* Navigation menu */}
            <MedialFacilityNav medicalFacility={medicalFacility} />

            {/* Giới thiệu bệnh viện */}
            <HospitalIntro {...medicalFacilityWithMap} onOpenMap={handleOpenMap} />

            {/* Danh sách bác sĩ */}
            <MedicalFacilityDoctors {...props} />

            {/* Chuyên khoa */}
            <Specialties medicalFacility={medicalFacility} />

            {/* Dịch vụ y tế */}
            <MedicalFacilityServiceSection medicalFacility={medicalFacility} />

            {/* Hình ảnh cơ sở vật chất */}
            <InfrastructureCarousel medicalFacility={medicalFacility} />

            {/* Đánh giá của bệnh nhân */}
            <MedicalFacilityCustomerComments medicalFacility={medicalFacility} />

            {/* Form đặt lịch khám */}
            <FormRegister hospitals={hospitals} />
            {/* Google Map popup */}
            <GoogleMapView mapUrl={selectedMapUrl} open={open} onClose={() => setOpen(false)} />
        </BookingProvider>
    );
}
